import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=c35cc5a0&scoped=true"
import script from "./Position.vue?vue&type=script&lang=ts"
export * from "./Position.vue?vue&type=script&lang=ts"
import style0 from "./Position.vue?vue&type=style&index=0&id=c35cc5a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35cc5a0",
  null
  
)

export default component.exports